module.exports = __webpack_public_path__ + "static/media/theGreenJacket.9b8c76bb.jpg";